import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgConfirmActionUrl from '@/assets/misc/img_confirm-action.svg'
import WorkspaceRolesIllustration from '@/components/SpotIllustration/WorkspaceRolesIllustration'

export interface IgnoreMergeRequestDialogProps {
  showing: boolean
  onClose: () => unknown
  onIgnore: () => unknown
  isIgnorePending: boolean
  customerDisplayName: string
}

export function IgnoreMergeRequestDialog({
  showing,
  onClose,
  onIgnore,
  isIgnorePending,
  customerDisplayName,
}: IgnoreMergeRequestDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isIgnorePending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgConfirmActionUrl}
            illustration={byDesign(undefined, WorkspaceRolesIllustration)}
            alt="Illustration of a confused person with a question mark bubble above their head"
          />
          <ModalSheetContentTitle>
            You're about to ignore this merge request
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            <strong>{customerDisplayName}</strong>'s merge request will be
            removed from the list and ignored. They will not be notified and no
            action will be taken against their accounts.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            isDisabled={isIgnorePending}
            onPress={onClose}
          />
          <Button
            label="Ignore Request"
            isDisabled={isIgnorePending}
            variant="destructive"
            onPress={onIgnore}
            isPending={isIgnorePending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
